var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ComposedMenuItemCollapsible',{attrs:{"link-tag":"button","to":"#","title":_vm.$t('2FA'),"prefixIcon":{
        name: '2fa',
        path: 'activatable',
        activatable: true,
    },"link-tag-props":{ id: 'auth-account-details-2fa-button' }},on:{"input":_setup.handleToggle},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_c('BaseSwitchOnly',{attrs:{"value":_setup.switcherState,"readonly":true}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }